/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { string, bool } from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
const Loader = ({ text, cover, className, ...rest }) => (React.createElement("div", { className: setClass('b-loader', cover && 'b-loader--cover', className), ...rest },
    React.createElement(Icon, { name: "arrows-rotate", className: "b-loader__icon" }),
    React.createElement("div", { className: "b-txt-ctrl1" }, text)));
Loader.propTypes = {
    text: string,
    cover: bool,
    className: string,
};
Loader.defaultProps = {
    text: 'Loading...',
    cover: true,
    className: undefined,
};
export default Loader;
